import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Card, CardHeader, Table } from 'reactstrap'


const propTypes = {
  seller: PropTypes.shape({
    id     : PropTypes.number,
    name   : PropTypes.string,
    email  : PropTypes.string,
    mobile : PropTypes.string
  }),
  handleClickEditSeller: PropTypes.func
}

const defaultProps = {
  handleClickEditSeller: () => {}
}

/**
 * @param {object} seller
 */
const SellerDetailCard = ({
  seller,
  handleClickEditSeller
}) => (
  <Card>
    <CardHeader>
      <div>
        <span className='small text-uppercase text-light font-weight-bolder'>
          { 'seller' }
        </span>
        <h2>
          <span className='mr-3'>{ seller?.name }</span>
        </h2>
      </div>
    </CardHeader>

    <Table size='sm' responsive hover className='mb-0'>
      <tbody>
        <tr>
          <th scope='row'>ID</th>
          <td>{ seller?.id }</td>
        </tr>
        <tr>
          <th scope='row'>Email</th>
          <td>{ seller?.email }</td>
        </tr>
        <tr>
          <th scope='row'>Phone Number</th>
          <td>{ seller?.mobile }</td>
        </tr>
      </tbody>
    </Table>

    <Button
      className='m-3'
      color='primary'
      onClick={ () => { handleClickEditSeller(seller?.id) } }
    >
      { 'Edit Seller' }
    </Button>
  </Card>
)

SellerDetailCard.propTypes    = propTypes
SellerDetailCard.defaultProps = defaultProps

export default withLoader(SellerDetailCard, CardLoader)
